var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.$t('navBar.header.aboutUs'),"left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('p',[_vm._v("这里是关于我们页面。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }